import API from './api';

export const getPulseAlerts = (params = {}) => API.get('/intelligence/pulse', { params });
